import {useRef as $55OHh$useRef, useEffect as $55OHh$useEffect} from "react";
import {select as $55OHh$select} from "d3-selection";
import {axisLeft as $55OHh$axisLeft} from "d3-axis";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $4bJ9d = parcelRequire("4bJ9d");



var $aVUB5 = parcelRequire("aVUB5");
const $754b62486b701999$var$__d3axisKeys = [
    "ticks",
    "tickArguments",
    "tickValues",
    "tickFormat",
    "tickSize",
    "tickSizeInner",
    "tickSizeOuter",
    "tickPadding"
];
function $754b62486b701999$export$59643c0aa17d0c6f(props) {
    const { scale: scale } = (0, $aVUB5.useColumn)();
    return (0, $4bJ9d.default)($754b62486b701999$export$25ce20521d0ab97d, {
        scale: scale,
        ...props
    });
}
function $754b62486b701999$export$25ce20521d0ab97d(props) {
    const { showLabel: showLabel, className: className, showDomain: showDomain = true, tickSpacing: tickSpacing = 60, scale: scale } = props;
    const range = scale.range();
    const pixelHeight = Math.abs(range[0] - range[1]);
    let tickValues = undefined;
    if (pixelHeight < 3 * tickSpacing || scale.ticks(2).length < 2) {
        // Push ticks towards extrema
        const t0 = scale.ticks(4);
        tickValues = [
            t0[0],
            t0[t0.length - 1]
        ];
    }
    const defaultProps = {
        ticks: Math.max(Math.round(pixelHeight / tickSpacing), 2),
        // Suppress domain endpoints
        tickSizeOuter: 0,
        tickValues: tickValues
    };
    const ref = (0, $55OHh$useRef)(null);
    const axisRef = (0, $55OHh$useRef)((0, $55OHh$axisLeft)());
    const deps = $754b62486b701999$var$__d3axisKeys.map((k)=>props[k]);
    (0, $55OHh$useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        axisRef.current.scale(scale);
        for (let k of $754b62486b701999$var$__d3axisKeys){
            const val = props[k] ?? defaultProps[k];
            if (val == null) continue;
            axisRef.current[k](val);
        }
        const ax = (0, $55OHh$select)(el).call(axisRef.current);
        if (!showDomain) ax.select(".domain").remove();
        ax.selectAll(".tick text").each(function(d) {
            if (!(showLabel?.(d) ?? true)) (0, $55OHh$select)(this).attr("visibility", "hidden");
        });
        return ()=>{
            (0, $55OHh$select)(el).selectAll("*").remove();
        };
    }, [
        scale,
        ref.current,
        showDomain,
        showLabel,
        ...deps
    ]);
    return (0, $4bJ9d.default)("g.y.axis.column-axis", {
        className: className,
        ref: ref
    });
}


//# sourceMappingURL=axis.eb573ddf.js.map
